// Shared helper: build this week's calendar list (today through Sunday) for a single church,
// grouped by day for compact rendering on the homepage.
const LOCALE_BY_LANG = {
  sv: 'sv-SE',
  en: 'en-US',
  pl: 'pl-PL',
  es: 'es-ES',
  fr: 'fr-FR',
  ar: 'ar',
};

export const getChurchWeeklySchedule = (churchEvents, language = 'sv') => {
  const locale = LOCALE_BY_LANG[language] || 'sv-SE';
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const daysUntilSunday = (7 - today.getDay()) % 7;
  const endOfWeek = new Date(today);
  endOfWeek.setDate(today.getDate() + daysUntilSunday);
  endOfWeek.setHours(23, 59, 59, 999);

  const items = (churchEvents || [])
    .map((event) => {
      const startDate = new Date(event.start_datetime);
      if (Number.isNaN(startDate.getTime())) return null;
      if (startDate < today || startDate > endOfWeek) return null;
      const dateKey = startDate.toISOString().split('T')[0];
      const dateLabel = startDate.toLocaleDateString(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
      });
      const time = startDate.toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
      const title = event.title || event.summary || event.description || '';
      return { startDate, dateKey, dateLabel, time, title };
    })
    .filter(Boolean)
    .sort((a, b) => a.startDate - b.startDate);

  const grouped = {};
  items.forEach((item) => {
    if (!grouped[item.dateKey]) {
      grouped[item.dateKey] = { dateLabel: item.dateLabel, items: [] };
    }
    grouped[item.dateKey].items.push({ time: item.time, title: item.title });
  });

  return Object.values(grouped);
};
